import { Box, Stack } from '@mui/material'
import Image from 'next/image'
import Link from 'next/link'
import { useRouter } from 'next/router'
import MBOLogo from '../../public/MBO_logo_white.jpg'

export type LogoProps = {
  variant?: 'light' | 'dark'
  isoCode?: string
  role?: string
}

const Logo = ({ variant = 'light', isoCode, role }: LogoProps) => {
  const { defaultLocale } = useRouter()

  const normalizedIso = isoCode?.toUpperCase()
  const normalizedLocale = defaultLocale?.toLowerCase()
  //const normalizedRole = role?.toLowerCase()

  //const isAdminOrLibrarian =
  // normalizedRole === 'hlo-admin' || normalizedRole === 'librarian'

  // Final logic to determine Danish logo or not
  const isDanish =
    (!normalizedIso && normalizedLocale === 'da') ||
    (normalizedIso && normalizedLocale === 'da') ||
    normalizedIso === 'DK'

  const iconImgSrc =
    variant === 'dark' ? '/HL_logo_icon_white.svg' : '/HL_logo_icon.svg'
  const textImgSrc =
    variant === 'dark' ? '/HL_logo_text_white.svg' : '/HL_logo_text.svg'

  return (
    <Link href="/" passHref>
      <a>
        {isDanish ? (
          <Image
            alt="Menneskebiblioteket Logo"
            objectFit="cover"
            src={MBOLogo}
            height={23.5}
            width={200}
            unoptimized={process.env.NODE_ENV === 'development'}
          />
        ) : (
          <Stack
            alignItems="center"
            direction="row"
            spacing="2.69px"
            height="32px"
          >
            <Box
              sx={{
                cursor: 'pointer',
                display: 'flex',
                maxWidth: 230,
                minWidth: 23.5,
                minHeight: 32,
              }}
            >
              <Image
                alt="The Human Library Logo Icon"
                height={32}
                width={23.5}
                objectFit="contain"
                src={iconImgSrc}
                unoptimized={process.env.NODE_ENV === 'development'}
              />
            </Box>
            <Box
              sx={{
                cursor: 'pointer',
                display: 'flex',
                maxWidth: 230,
                minWidth: 177.45,
                minHeight: 23.5,
              }}
            >
              <Image
                alt="The Human Library Logo Title Text"
                src={textImgSrc}
                height={23.5}
                width={177.45}
                unoptimized={process.env.NODE_ENV === 'development'}
              />
            </Box>
          </Stack>
        )}
      </a>
    </Link>
  )
}

export default Logo
